function createProductAttributeSortInput(sortData) {
  const baseData = sortData.split(/_/gi);
  if (baseData.length > 2) {
    const dir = baseData.pop();
    const by = baseData.join("_");
    return Object.fromEntries([[by, dir]]);
  }
  return baseData.length > 0 ? Object.fromEntries([baseData]) : {};
}
export {
  createProductAttributeSortInput
};
